<label
	[class]="
		cn(
			!isDisabled() && 'cursor-pointer',
			stacked() && 'control-selection-card-stacked',
			isSelected() && 'control-selection-card-selected',
			isDisabled() && 'cursor-not-allowed opacity-50',
			hasCardsAsMarkdown() && 'px-7 py-6',
			'control-selection-card'
		)
	"
	[for]="option().inputId"
	(keydown.enter)="changedValue(option().inputId)"
	data-test-class="selection-card-option"
	tabindex="0"
>
	@if (option().icon) {
		<svg-icon
			[class]="
				cn('icon-container', stacked() && 'control-selection-card-icon')
			"
			[src]="option().icon!"
		/>
	}
	<div
		[class]="cn(option().byline && 'gap-1', stacked() && 'items-center')"
		class="flex flex-1 flex-col"
	>
		<div
			[class]="cn((option().byline || stacked()) && 'font-semibold')"
			class="leading-4"
		>
			{{ option().label | translate }}
		</div>

		@if (hasCardsAsMarkdown()) {
			<markdown [data]="option().byline" class="leading-6" />
		} @else if (option().byline) {
			<div class="leading-5">{{ option().byline | translate }}</div>
		}
	</div>
	<input
		[attr.aria-describedby]="option().inputId"
		[attr.aria-labelledby]="option().inputId"
		[attr.data-test-id]="option().inputId"
		[checked]="isSelected()"
		[class]="
			cn(
				hideNativeInput() && 'hidden',
				hasError() &&
					!isDisabled() &&
					!isReadonly() &&
					'shadow-error-100',
				controlType() === 'radio' && 'control-radio',
				controlType() === 'checkbox' && 'control-checkbox',
				'flex-none shrink-0'
			)
		"
		[disabled]="isDisabled()"
		[id]="option().inputId"
		[name]="name()"
		[type]="controlType()"
		(change)="changedValue(option().inputId)"
	/>
</label>
